// extracted by mini-css-extract-plugin
export default {"PromptSave":"PromptSave_PromptSave Prompt_PromptWidthOfMainContent Prompt_Prompt","slideIn":"PromptSave_slideIn","slideOut":"PromptSave_slideOut"};